import type { SerializedQuery } from "@glide/computation-model-types";
import { isLiveUpdateQuery, isRowVersionCapableQuery } from "@glide/computation-model-types";

export class RowVersions {
    private readonly _versions = new Map<string, number>();

    update(queryID: string, query: SerializedQuery, newVersion: number | undefined): void {
        if (newVersion === undefined) return;

        const current = this._versions.get(queryID);
        if (current === undefined || isLiveUpdateQuery(query)) {
            this._versions.set(queryID, newVersion);
        }
    }

    makeQuery(queryID: string, query: SerializedQuery, endOfTable: boolean): SerializedQuery {
        if (!this.useRowVersion(query, endOfTable)) return query;

        const rowVersion = this._versions.get(queryID);
        if (rowVersion === undefined) return query;

        return { ...query, rowVersion };
    }

    private useRowVersion(query: SerializedQuery, endOfTable: boolean): boolean {
        return endOfTable && isRowVersionCapableQuery(query);
    }
}
